import { CustomFilterMeta } from '@src/main/modules/messages/ui/mailbox/views/mailbox/mailbox.types';
import { differenceInDays } from 'date-fns';
import { DataTableFilterEvent } from 'primereact/datatable';

export const handleDateRangeFilter = (
  e: DataTableFilterEvent,
  setFilters: (f: CustomFilterMeta) => void,
  showInvalidDateModal: () => void,
) => {
  const newFilters = e.filters as CustomFilterMeta;
  const dateConstraint = newFilters.sendDate?.constraints?.[0];
  const dateFilter = dateConstraint?.value as (Date | null)[] | null;

  if (dateFilter && Array.isArray(dateFilter)) {
    const [start, end] = dateFilter;
    if (start && end && differenceInDays(end, start) > 365) {
      showInvalidDateModal();
      return;
    }
  }

  setFilters(newFilters);
};
